import * as XLSX from 'xlsx';
import LuckyExcel from 'luckyexcel'
import { cloneDeep } from 'lodash';
import { getOrgShowName } from "@/api/global.js";
const luckysheet = window.luckysheet // 表格实例

export default {
  data () {
    return {
      _xlsxType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      _xlsType: 'application/vnd.ms-excel',
      _csvType: 'text/csv',
      errorText: ['(请填写数字)', '(必填)', '找不到', '(请按yyyy-MM-dd格式填写日期)'],
      currentExcelFile: null,
      headerList: [],
      tableData: []
    }
  },
  methods: {
    async initExcel (excelUrl) {
      const path = excelUrl || 
      (
        this.importTemplate.value === 1 && this.importTemplate.customTemplateUrl ? 
          this.importTemplate.customTemplateUrl :
          await this.getDefaultTemp()
      )
      if (!path) return this.$message.error('模板有误，请联系管理员！')
      const name = this.getFileName(path)
      let user = localStorage.getItem('user')
      let url = this.$apiurl + '/' + path
      if (user) {
        user = JSON.parse(user)
        const accesstoken = user.accesstoken
        url += '?accesstoken=' + accesstoken
      }
      const blob = await this.getBlobFromURL(url)
      const file = this.getExcelFile(blob, name)
      this.currentExcelFile = file
      this.handleExcelFile(file)
    },
    // 创建Luckysheet
    createLuckySheet (file) {
      // 销毁已存在的Luckysheet
      // 将Excel文件转换为Luckysheet的json
      const that = this
      // 是否有二级控件
      that.isSecond = false
      LuckyExcel.transformExcelToLucky(file, function (exportJson) {
        if (exportJson.sheets == null || exportJson.sheets.length === 0) {
          throw new Error("Failed to load excel file");
        }
        const multistage = ['new-rel-radio', 'details', 'ready-widget']
        const property = that.property.filter(item => { return !item.viewHide })
        // 单选关联在模板里面是一级控件
        const index = property.findIndex(item => { return ['details', 'ready-widget'].includes(item.type)})
        if (index !== -1) {
          that.isSecond = true
        }
        property.filter(item => { return multistage.includes(item.type) }).
        forEach(item => { if (item.list && item.list.length > 0) {
          const detailsList = item.list.map(list => {
            // 保留一下数据明细内的标记
            list.ftitle = item.title
            list.ftype = item.type
            // 单选关联里面可能会嵌套预约控件
            if (item.type === 'ready-widget') {
              that.isSecond = true
            }
            return list
          })
          property.push(...detailsList)
        }})
        exportJson.sheets.forEach(item => {
          item.celldata.forEach(cell => {
            // 表头一般都是前两行
            let headRow = that.isSecond ? 2 : 1
            if (that.isUpdateById) {
              headRow = that.pivotHeadLength
            }
            if (cell.v && cell.v.v) {
              if (cell.r < headRow) {
                cell.v.bl = 1
                cell.v.ht = 0
                cell.v.isHead = true
                cell.v.bg = '#fff2cc'
                // 原型需求把必填的字眼去掉标红 有问题再改回去
                if (cell.v.v.search('（必填）') !== -1) {
                  cell.v.fc = '#cc0000'
                  cell.v.v = cell.v.v.replace('（必填）', '')
                }
                that.headerList.push(cell)
              } else {
                const index = property.findIndex(item => { return item.col === cell.c })
                if (index !== -1) {
                  // 如果日期类型的控件有值 那就直接转换成日期格式
                  if (property[index].type === 'date') {
                    const format = property[index].match || 'yyyy-MM-dd'
                    cell.v.ct = {
                      fa: format,
                      t: 'd'
                    }
                  } else if (property[index].type === 'text' || property[index].type === 'number') {
                    // 数字和文本就是纯文本格式
                    const ct = {
                      fa: '@',
                      t: 's'
                    }
                    cell.v.ct = ct
                  }
                } else {
                  // 不存在配置里面的大概是单号 也改为纯文本格式
                  const ct = {
                    fa: '@',
                    t: 's'
                  }
                  cell.v.ct = ct
                }
                // 错误提示标红
                for (let index = 0; index < that.errorText.length; index++) {
                  const text = that.errorText[index];
                  if (cell.v.v.search(text) !== -1) {
                    cell.v.bg = '#cc0000'
                    continue
                  }
                }
                if (that.tableData[cell.r - headRow] === undefined) that.tableData[cell.r - headRow] = []
                that.tableData[cell.r - headRow].push(cell)
              }
              cell.v.tb = 2
              const cellValue = cell.v.v.trim()
              const index = property.findIndex(iter => {
                if (cell.r === 1 && !that.isUpdateById) {
                  // 数据id更新不要走这边
                  // 第二行说明是二级控件的
                  return iter.ftype && (iter.name === cellValue || (iter.name + '（必填）') === cellValue)
                } else {
                  return iter.name === cellValue || (iter.name + '（必填）') === cellValue
                }
              })
              if (index !== -1 && property[index].type !== 'details') {
                // 明细的配置别加进去
                // 保存一下每一列的配置
                const key = `${property[index].title}_${property[index].type}`
                // 不存在才写入进去
                if (that.colConfg[key] === undefined) {
                  property[index].col = cell.c
                  // 必填字段的列
                  if (!property[index].ftype && property[index].required === 'required') {
                    that.requiredFieldCol.push(cell.c)
                  }
                  that.colConfg[key] = property[index]
                }
              }
            } else {
              if (cell.r < headRow) {
                cell.v.isHead = true
                cell.v.bg = '#fff2cc'
              }
            }
          })
          if (that.isUpdateById) {
            // 数据id更新的情况下只保留头部
            item.celldata = cloneDeep(that.headerList)
          }
          // 设置要隐藏的列
          if (that.hideCol.length > 0) {
            item.config.colhidden = {}
            that.hideCol.forEach(iten => {
              if (iten.col !== undefined) {
                item.config.colhidden[iten.col] = 0
              }
            })
          }
        })
        if (that.isUpdateById) {
          that.dealByIdData(exportJson.sheets)
        } else if ((that.btnImportType !== 'file' || that.isAiDrop) && that.fillInData.length > 0) {
          // 文件打开的不需要初始化默认值
          that.dealFillInData(exportJson.sheets)
        }
        that.options.data = exportJson.sheets
        // 按钮的导入更新去掉默认的行数
        if (that.queryConfig.importModeValue === '1') {
          that.options.row = 0
        }
        luckysheet.create(that.options);
      });
    },
    // 值改变后处理要填入的值
    dealDefaultInData ({ row, item }) {
      // 更新数据不填入默认值
      if (this.importModeValue === 1 || Object.keys(this.defaultInData).length === 0 || !item) return false
      const currentKey = `${item.title}_${item.type}` // 当前修改单元格的key
      for (const key in this.defaultInData) {
        if (key.search('details') !== -1) {
          // 处理明细默认值
          this.dealDetailsFillInData(key, row)
        } else {
          if (key === currentKey) continue
          let value = this.defaultInData[key]
          const rowIndex = row
          const cellConfig = this.colConfg[key]
          if (cellConfig) {
            const colIndex = cellConfig.col
            // 存在值就不要在设置了
            if (luckysheet.getCellValue(rowIndex, colIndex)) continue
            if (Array.isArray(value)) {
              if (['relation-user', 'organization', 'roule'].includes(cellConfig.type)) {
                value = Array.isArray(value) ? value.map(item => { return (item.realname || item.name ) + `(${item.userId || item.organizationId || item.roleId})`}) : []
              }
              value = value.join(',')
            }
            luckysheet.setCellValue(rowIndex, colIndex, value)
          }
        }
      }
    },
    // 处理明细的默认值
    dealDetailsFillInData (detailsKey, startRow) {
      let valueList = this.defaultInData[detailsKey]
      const colAll = luckysheet.getSheet().visibledatacolumn.length - 1
      // 循环每条数据 只填一整行空白的行 碰到有数据的一行停止
      for (const list of valueList) {
        for (const key in list) {
          let value = list[key]
          const cellConfig = this.colConfg[key]
          if (value && cellConfig) {
            // 存在值就不要在设置了
            const colIndex = cellConfig.col
            if (luckysheet.getCellValue(startRow, colIndex)) continue
            if (Array.isArray(value)) {
              if (['relation-user', 'organization', 'roule'].includes(cellConfig.type)) {
                value = Array.isArray(value) ? value.map(item => { return (item.realname || item.name ) + `(${item.userId || item.organizationId || item.roleId})`}) : []
              }
              value = value.join(',')
            }
            luckysheet.setCellValue(startRow, colIndex, value)
          }
        }
        startRow++
        // 判断下行有没有数据 有数据就停止
        let data = luckysheet.getRangeArray('oneDimensional', { range: { row: [startRow, startRow], column: [0, colAll] } })
        if (data.find(item => { return item || item === 0 })) continue
      }
    },
    // 之前一打开就处理要填入的值
    dealFillInData (sheets) {
      const startRow = this.isSecond ? 2 : 1
      // 自定义导入选择更新的，如果选择编号要把联系人id也填进去
      const chooseField = this.queryConfig.chooseField || []
      const isShowId = chooseField.filter(item => { return item.id }).map(item => { return item.title })
      this.fillInData.forEach((row, index) => {
        const rowIndex = startRow + index
        for (const key in row) {
          const [title] = key.split('_')
          const value = row[key]
          let cellConfig = this.colConfg[key]
          // ai拖入导出返回的key是名字
          if (!cellConfig) {
            for (const i in this.colConfg) {
              if (this.colConfg[i].name === title) {
                cellConfig = this.colConfg[i]
                break
              }
            }
          }
          if (!cellConfig && this.queryConfig.importHeaderType === 'custom') {
            // 列转行的处理
            const headCell = this.headerList.find(cell => { return cell.v && cell.v.v === key })
            if (headCell) {
              cellConfig = {
                type: 'text',
                col: headCell.c
              }
            }
          }
          if (cellConfig) {
            let type = cellConfig.type
            let isNoEdit = false
            // 更新的字段只读
            if(this.queryConfig && this.queryConfig.importModeValue === '1') {
              const valueSearchList = this.queryConfig.valueSearchList ? JSON.parse(this.queryConfig.valueSearchList) : []
              isNoEdit = valueSearchList.find(item => {
                return item === (cellConfig.title + '_' + cellConfig.type)
              }) ? true : false
            }
            const colIndex = cellConfig.col
            const obj = {
              c: colIndex,
              r: rowIndex,
              v: {}
            }
            if (['relation-user', 'organization', 'roule'].includes(type)) {
              let val = Array.isArray(value) ? value.map(item => {
                let res = item.realname || item.name
                if (isShowId.includes(cellConfig.title)) {
                  res += `(${item.userId || item.organizationId || item.roleId })`
                }
                return res
              }) : typeof value === 'string' ? value.split(',') : []
              obj.v.v = val.join(',')
              obj.v.m = val.join(',')
            } else if (Array.isArray(value)) {
              obj.v.v = value.join(',')
              obj.v.m = value.join(',')
            } else {
              obj.v.v = value
              obj.v.m = value
            }
            if (isNoEdit) {
              obj.v.isReadOnly = true
            }
            sheets[0].celldata.push(obj)
          }
        }
      })
    },
    // 条件对比需要更新的数据（文件导入的数据和全部数据取交集）
    dealByIdData (sheets) {
      let { valueSearchList } = this.queryConfig
      valueSearchList = valueSearchList ? JSON.parse(valueSearchList) : []
      const colHead = {}
      const headCol = {}
      let fileData = []
      // const startRow = this.isSecond ? 1 : 0
      // 获取每列的字段名
      this.headerList.forEach(cell => {
        if (cell.v.isHead) {
          const item = this.property.find(item => {
            const name1 = item.name ? item.name.toLowerCase() : item.name
            const name2 = cell.v.v ? cell.v.v.toLowerCase() : cell.v.v
            return name1 === name2
          })
          colHead[cell.c] = item ? item.title : cell.v.v
          headCol[cell.v.v] = cell.c
        }
      })
      // 把表格数据转换为二维数据表
      this.tableData.forEach(listData => {
        const data = {}
        listData.forEach(cell => {
          // 获取每列表头的key 然后填入数据
          data[colHead[cell.c]] = cell.v.v
        })
        fileData.push(data)
      })
      const filterKey = valueSearchList.map(item => { return item.split('_')[0] })
      const res = this.filterFileData(fileData, filterKey)
      const { filteredData, duplicateInfo } = res
      fileData = filteredData
      if (duplicateInfo.length > 0) {
        let text = ''
        duplicateInfo.map(item => {
          text += `
          <p>匹配条件
            <strong style="color: red">${item.identifier}</strong>
            重复，所在位置第
            <strong style="color: red">${item.indices.map(index => { return index+=2 }).join()}</strong>
            行
          </p>`
        })
        this.$alert(`<p>您上传的文件存在<strong style="color: red">${duplicateInfo.length}</strong>处数据重复
          <span style="font-size: 12px; color: #999">（重复数据本次不更新，请修改导入数据后再次提交。）</span>：${text}</p>`, '数据重复', {
          dangerouslyUseHTMLString: true
        });
      }
      // 表格数据和全部数据取交集
      let rowNoVerify = 0 // 没验证通过的数据数量
      fileData.forEach((listData, index) => {
        let isInsert = false
        if (Object.keys(listData).length > 0 && valueSearchList.length > 0) {
          isInsert = this.isConditionInsert(listData, valueSearchList)
        }
        if (isInsert) {
          const rowData = cloneDeep(this.tableData[index])
          // 根据之前验证没通过的减少行数
          if (rowData) {
            rowData.forEach(cell => { cell.r = cell.r - rowNoVerify })
            sheets[0].celldata.push(...rowData)
          }
        } else {
          rowNoVerify++
        }
      })
    },
    isConditionInsert (formData, linkList = [], isGetData = false) {
      let flag = false
      let allData = cloneDeep(this.importAllData)
      linkList.forEach(linkKey => {
        const [title, type] = linkKey.split('_')
        let value = formData[title] || formData[`${title}_${type}`]
        value = Array.isArray(value) ? value[0] : value
        allData = allData.filter(item => {
          if (['relation-user', 'organization', 'roule'].includes(type)) {
            // 如果是联系人等数组的数据 就取各自的第一个值
            return item[title].map(iten => {
              if (item.organizationId) {
                return getOrgShowName(item)
              } else {
                return iten.realname || iten.name
              }
            })[0] === value.split('(')[0]
          } else {
            return value === item[title]
          }
        })
      })
      if (allData.length === 1) {
        flag = isGetData ? allData[0] : true
      } else if (allData.length > 1) {
        // todo
      }
      return flag
    },
    // 去除匹配条件重复的数据
    filterFileData (dataArray, keyArray) {
      const seen = new Map(); // 记录每个标识符出现的次数和位置
      const result = []; // 结果数组
      const duplicateInfo = []; // 重复信息

      // 第一遍遍历：统计每个标识符的出现次数和所有位置
      dataArray.forEach((item, index) => {
        const identifier = keyArray.map(key => item[key]).join('|');

        if (!seen.has(identifier)) {
          seen.set(identifier, {
            count: 1,
            indices: [index]
          });
        } else {
          const info = seen.get(identifier);
          info.count += 1;
          info.indices.push(index);
        }
      });

      // 第二遍遍历：构建结果数组
      dataArray.forEach((item) => {
        const identifier = keyArray.map(key => item[key]).join('|');
        const info = seen.get(identifier);

        if (info.count === 1) {
          // 不重复的数据，保留原样
          result.push(item);
        } else {
          // 所有重复的数据（包括第一次出现的）都变成空对象
          result.push({});
        }
      });

      // 整理重复信息
      seen.forEach((info, identifier) => {
        if (info.count > 1) {
          duplicateInfo.push({
            identifier: identifier,
            indices: info.indices,
            count: info.count,
            data: dataArray[info.indices[0]] // 取第一条数据作为示例
          });
        }
      });

      return {
        filteredData: result, // 所有重复的数据都变成空对象
        duplicateInfo: duplicateInfo,
        duplicateCount: duplicateInfo.length,
        totalDuplicates: dataArray.length - result.filter(item => Object.keys(item).length > 0).length
      };
    },
    // 根据url获取blob
    getBlobFromURL(url) {
      return new Promise( resolve => {
        var xhr = new XMLHttpRequest();
          xhr.open('get', url, true);
          xhr.responseType = 'arraybuffer';
          xhr.onload = function() {
            if(xhr.status == 200) {
              resolve(xhr.response)
            }
          };
          xhr.send();
      })
    },
    // 把blob转换成file
    getExcelFile(res, fileName) {
      // 根据文件后缀名判断文件类型
      if (fileName.endsWith('.xlsx')) {
        return new File([res], fileName, {type: this._xlsxType});
      } else if (fileName.endsWith('.xls')) {
        return new File([res], fileName, {type: this._xlsType});
      } else if (fileName.endsWith('.csv')) {
        return new File([res], fileName, {type: this._csvType});
      } else {
        throw new Error("Unsupported file type");
      }
    },
    // 处理Excel文件
    handleExcelFile (file)  {
      const fileName = file.name;
      // 根据文件后缀名判断文件类型并进行处理
      if (fileName.endsWith('.xlsx')) {
        console.log("handle excel for xlsx type..", fileName);
        this.handleExcelForXlsxType(file, fileName);
      } else if (fileName.endsWith('.xls') || fileName.endsWith('.csv')) {
        console.log("handle excel for xls or csv type..", fileName);
        this.handleExcelForXlsAndCsvType(file, fileName);
      } else {
        throw new Error("Unsupported file type");
      }
    },
    // 处理xlsx类型的Excel文件
    handleExcelForXlsxType (file, fileName) {
      const reader = new FileReader();
      const that = this
      reader.onload = function (event) {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, {type: 'array'});
        // 获取工作表
        // const sheet = workbook.Sheets[workbook.SheetNames[0]];
        // console.log(sheet, 'workbook')
        // 获取Excel文件中的最大行数
        let maxRowCountFromExcel = that.getMaxRowCountFromExcel(workbook);
        // 如果行数大于100000，则处理Excel文件中的空行
        if (maxRowCountFromExcel > 1000000) {
          console.log("excel file has too many blank row..", maxRowCountFromExcel);
          that.handleBlankRowForExcelWithTooManyBlankRow(workbook);
          const xlsxFile = that.toXlsxExcelFile(workbook, fileName);
          that.createLuckySheet(xlsxFile);
        } else {
          that.createLuckySheet(file);
        }
      };
      reader.readAsArrayBuffer(file);
    },
    // 处理xls和csv类型的Excel文件
    handleExcelForXlsAndCsvType (file, fileName) {
      const reader = new FileReader();
      const that = this
      // 读取文件完成后的回调函数
      reader.onload = async function (event) {
        const data = new Uint8Array(event.target.result);
        // 读取Excel文件内容
        const workbook = XLSX.read(data, {type: 'array'});
        // 将Excel文件转换为xlsx类型
        const xlsxFile = that.toXlsxExcelFile(workbook, fileName);
        // 处理xlsx类型的Excel文件
        that.handleExcelForXlsxType(xlsxFile, fileName);
      };
      // 以ArrayBuffer的形式读取文件
      reader.readAsArrayBuffer(file);
    },
    // 获取Excel文件中的最大行数
    getMaxRowCountFromExcel (workbook) {
      let maxRowCount = 0;
      if (workbook.SheetNames == null || workbook.SheetNames.length === 0) {
        return maxRowCount;
      }
      // 遍历每个sheet，获取最大行数
      workbook.SheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        if (worksheet['!ref'] === undefined) {
          return;
        }
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        maxRowCount = maxRowCount + range.e.r;
      });
      return maxRowCount;
    },
    reduceBlankRow (row, range, worksheet) {
      // 从给定的行开始，向上遍历到工作表的起始行
      while (row > range.s.r) {
      // 假设当前行是空的
        let allEmpty = true;
        // 遍历当前行的所有列
        for (let col = range.s.c; col <= range.e.c; col++) {
        // 获取当前单元格的引用
          const cell_ref = XLSX.utils.encode_cell({c: col, r: row});
          // 如果当前单元格不为空，则将allEmpty设置为false并跳出循环
          if (worksheet[cell_ref]) {
            allEmpty = false;
            break;
          }
        }
        // 如果当前行是空的，则将行数减一，否则跳出循环
        if (allEmpty) {
          row--;
        } else {
          break;
        }
      }
      // 更新工作表范围的结束行
      range.e.r = row;
      // 更新工作表的范围引用
      worksheet['!ref'] = XLSX.utils.encode_range(range.s, range.e);
    },
    // 处理Excel文件中的空行
    handleBlankRowForExcelWithTooManyBlankRow (workbook) {
      if (workbook.SheetNames == null || workbook.SheetNames.length === 0) {
        return;
      }
      // 遍历每个sheet，处理空行
      workbook.SheetNames.forEach(sheetName => {
        const worksheet = workbook.Sheets[sheetName];
        if (worksheet['!ref'] === undefined) {
          return;
        }
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        let row = range.e.r;
        this.reduceBlankRow(row, range, worksheet);
      });
    },
    // 将Excel文件转换为xlsx类型
    toXlsxExcelFile(workbook, fileName) {
      const newWorkbook = XLSX.write(workbook, {bookType: 'xlsx', type: 'binary'});
      const data = new Uint8Array(newWorkbook.length);
      for (let i = 0; i < newWorkbook.length; i++) {
        data[i] = newWorkbook.charCodeAt(i);
      }
      return new File([data], fileName, {type: this._xlsxType});
    },
  }
}